import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	// vue分别重定向多个路由
	{
		path: '',
		redirect: '/home',
	},
	// http://localhost:9521/#/tianRuiDe/paypalOrder
	{
		path: '/tianRuiDe/paypalOrder',
		redirect:'/notFound'
	},
	// http://localhost:9521/#/chengHuiRu/paypalOrder
	{
		path: '/chengHuiRu/paypalOrder',
		redirect:'/notFound'
	},
	// http://localhost:9521/#/shiFangTang/paypalOrder
	{
		path: '/shiFangTang/paypalOrder',
		redirect:'/notFound'
	},
	{
		// http://localhost:9521/#/chengHuiRu/PW
		path: '/chengHuiRu/PW',
		redirect: to => {
			const newQuery = {web:'chengHuiRu'};
			return { path: '/PW', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/chengHuiRu/szOrder
		path: '/chengHuiRu/szOrder',
		redirect: to => {
			const newQuery = {web:'chengHuiRu'};
			return { path: '/szOrder', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/chengHuiRu/payerMax
		path: '/chengHuiRu/payerMax',
		redirect: to => {
			const newQuery = {web:'chengHuiRu'};
			return { path: '/payerMax', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/shiFangTang/PW
		path: '/shiFangTang/PW',
		redirect: to => {
			const newQuery = {web:'shiFangTang'};
			return { path: '/PW', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/shiFangTang/szOrder
		path: '/shiFangTang/szOrder',
		redirect: to => {
			const newQuery = {web:'shiFangTang'};
			return { path: '/szOrder', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/shiFangTang/payerMax
		path: '/shiFangTang/payerMax',
		redirect: to => {
			const newQuery = {web:'shiFangTang'};
			return { path: '/payerMax', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/tianRuiDe/PW
		path: '/tianRuiDe/PW',
		redirect: to => {
			const newQuery = {web:'tianRuiDe'};
			return { path: '/PW', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/tianRuiDe/szOrder
		path: '/tianRuiDe/szOrder',
		redirect: to => {
			const newQuery = {web:'tianRuiDe'};
			return { path: '/szOrder', query: newQuery };
		}
	},
	{
		// http://localhost:9521/#/tianRuiDe/payerMax
		path: '/tianRuiDe/payerMax',
		redirect: to => {
			const newQuery = {web:'tianRuiDe'};
			return { path: '/payerMax', query: newQuery };
		}
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import('views/home.vue'),
	},

	// 新的架构
	{
		path: '/bill/InfoBill',
		name: 'InfoBill',
		component: () => import('views/bill/InfoBill.vue'),
	},
	{
		path: '/shiFangTang',
		name: 'ShiFangTang',
		component: () => import('views/Webs/shiFangTang.vue'),
	},
	{
		path: '/tianRuiDe',
		name: 'TianRuiDe',
		component: () => import('views/Webs/tianRuiDe.vue'),
	},
	{
		path: '/chengHuiRu',
		name: 'ChengHuiRu',
		component: () => import('views/Webs/chengHuiRu.vue'),
	},
	{
		path: '/jiangchuan',
		name: 'jiangchuan',
		component: () => import('views/Webs/jiangchuan.vue'),
	},
	{
		path: '/zhouyu',
		name: 'zhouyu',
		component: () => import('views/Webs/zhouyu.vue'),
	},
	{
		path: '/yourui',
		name: 'yourui',
		component: () => import('views/Webs/yourui.vue'),
	},
	{
		path: '/hongju',
		name: 'hongju',
		component: () => import('views/Webs/hongju.vue'),
	},
	{
		path: '/jieheng',
		name: 'jieheng',
		component: () => import('views/Webs/jieheng.vue'),
	},
	{
		path: '/jinxin',
		name: 'jinxin',
		component: () => import('views/Webs/jinxin.vue'),
	},
	// 统一404页面
	{
		path: '/notFound',
		name: 'notFound',
		component: () => import('views/notFound.vue'),
	},
	// 统一PayerMax
	{
		path: '/payerMax',
		name: 'payerMax',
		component: () => import('views/Orders/payerMax.vue'),
	},
	// 统一SZ
	{
		path: '/szOrder',
		name: 'szOrder',
		component: () => import('views/Orders/szOrder.vue'),
	},
	// 统一PayPal
	{
		path: '/paypalOrder',
		name: 'paypalOrder',
		component: () => import('views/Orders/paypalOrder.vue'),
	},
	// 统一PW
	{
		path: '/PW',
		name: 'PW',
		component: () => import('views/Orders/PW.vue'),
	},
	// 统一Ps
	{
		path: '/psOrder',
		name: 'psOrder',
		component: () => import('views/Orders/psOrder.vue'),
	},
	// 统一Cp
	{
		path: '/cpOrder',
		name: 'cpOrder',
		component: () => import('views/Orders/cpOrder.vue'),
	},
	// 统一支付宝
	{
		path: '/zhifubao',
		name: 'zhifubao',
		component: () => import('views/Orders/zhifubao.vue'),
	},
	// 统一银行卡支付
	{
		path: '/bankCardOrder',
		name: 'bankCardOrder',
		component: () => import('views/Orders/bankCardOrder.vue'),
	},
	// 统一va收款
	{
		path: '/vaOrder',
		name: 'vaOrder',
		component: () => import('views/Orders/vaOrder.vue'),
	},
	// 统一hkpay收款
	{
		path: '/hkpayOrder',
		name: 'hkpayOrder',
		component: () => import('views/Orders/hkpayOrder.vue'),
	},
	// 账户创建VA
	{
		path: '/accountCreateVa',
		name: 'accountCreateVa',
		component: () => import('views/Orders/hkpayVaOrder/accountCreateVa.vue'),
	},
	// 一次性账户收款VA
	{
		path: '/accountOnePayVa',
		name: 'accountOnePayVa',
		component: () => import('views/Orders/hkpayVaOrder/accountOnePayVa.vue'),
	},
	// hkPay Va收款选择
	{
		path: '/hkpayVaSelect',
		name: 'hkpayVaSelect',
		component: () => import('views/Orders/hkpayVaOrder/hkpayVaSelect.vue'),
	},
	// 
	{
		path: '/futurePay',
		name: 'futurePay',
		component: () => import('views/Orders/futurePay.vue'),
	},
]

const router = new VueRouter({
	mode: 'hash',
	// mode: 'history',
	// base: process.env.BASE_URL,
	routes,
})

export default router
